module.exports = __webpack_public_path__ + "images/stickers/pete-space.39ccf8f732940140ded9.png";